<!--
 * @Author: 仙道
 * @Date: 2022-10-18 21:33:00
 * @LastEditTime: 2022-10-18 21:40:09
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/eMaintenance/components/Class.vue
-->
<template>
  <a-tree :load-data="onLoadData" :tree-data="treeData" />
</template>

<script>
  export default {
    data () {
      return {
        treeData: [
          // { title: 'Expand to load', key: '0' },
          // { title: 'Expand to load', key: '1' },
          // { title: 'Tree Node', key: '2', isLeaf: true },
        ],
      };
    },
    created () {
      this.onLoadData()
    },
    methods: {
      onLoadData (treeNode) {

        return new Promise(resolve => {
          if (treeNode?.dataRef.children) {
            resolve();
            return;
          }
          setTimeout(() => {
            // treeNode?.dataRef.children = [
            //   { title: 'Child Node', key: `${treeNode.eventKey}-0` },
            //   { title: 'Child Node', key: `${treeNode.eventKey}-1` },
            // ]
            this.treeData = [
              { title: 'Expand to load', key: '0' },
              { title: 'Expand to load', key: '1' },
              { title: 'Tree Node', key: '2', isLeaf: true },
            ]
            resolve();
          }, 1000);
        });
      },
    },
  };
</script>
